import React from "react"
import PropTypes from "prop-types"
import moment from "moment-timezone"
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts"

import EcosuiteComponent, { Loading } from "@common/EcosuiteComponent"
import { GRAPH_COLORS } from "@common/module/EcosuiteView"

import DateRangeGraph from "./DateRangeGraph"
import GraphUtils from "@common/utils/GraphUtils"
import i18n from "src/i18n"

const { t } = i18n
export default class PowerFactorBarGraph extends DateRangeGraph {
  renderContent() {
    if (this.props.range && this.props.graphDatums) {
      const sourceIds = new Set()
      let data = Object.keys(this.props.graphDatums).map((dateKey) => {
        let datum = this.props.graphDatums[dateKey]
        let date = moment(dateKey)

        let data = {
          date: date.toDate(),
          time: date.toDate().getTime(),
          name: date.format("lll"),
        }

        Object.keys(datum.assetDatums).forEach((sourceId) => {
          sourceIds.add(sourceId)
          data[sourceId] = datum.assetDatums[sourceId].powerFactor
        })

        return data
      })

      if (data.length < 1) {
        return <div className="content-graph-empty">{`${t("energy.labels.power_factor_non_recorded")}`}</div>
      }

      let aggregation = this.props.aggregation
      let graphType = aggregation === "day" ? "linear" : "monotone"
      return (
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={data} margin={{ top: 5, right: 30, left: 0, bottom: 10 }} onClick={this.zoomDateRange}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={false} />
            <XAxis
              dataKey="time"
              type="number"
              scale="time"
              domain={this.getDomain(this.props.range, this.props.aggregation)}
              tickFormatter={(time) => {
                return GraphUtils.dateFormat(time, this.props.range, this.props.aggregation)
              }}
            />
            <YAxis />
            <Legend iconType="plainline" />
            <Tooltip content={<GraphTooltip range={this.props.range} aggregation={this.props.aggregation} />} />
            {[...sourceIds].map((sourceId, idx) => {
              return <Line key={sourceId} name={sourceId} type={graphType} dataKey={sourceId} stroke={GRAPH_COLORS[idx % GRAPH_COLORS.length]} dot={aggregation === "day"} />
            })}
          </LineChart>
        </ResponsiveContainer>
      )
    }

    return <Loading />
  }
}

class GraphTooltip extends EcosuiteComponent {
  static propTypes = {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.number,
  }

  renderContent() {
    const { active } = this.props
    if (active) {
      const { payload, label } = this.props
      if (payload) {
        return (
          <div className="area-graph-tooltip">
            <p className="label">{GraphUtils.formatDateTooltip(label, this.props.range, this.props.aggregation)}</p>
            {payload.map((data) => {
              return (
                <React.Fragment key={data.dataKey}>
                  <p className="label" style={{ color: data.stroke }}>
                    {`${data.name} : ${data.value ? data.value : 0}`}
                  </p>
                </React.Fragment>
              )
            })}
          </div>
        )
      }
    }
    return null
  }
}
